

































































































import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import EnumDetailBase from "./EnumDetailBase";

@Component
export default class EnumDetail extends EnumDetailBase {

	created() {
		super.initializeRights('COR_EnuTypeGroup_Read', 'COR_EnuTypeGroup_Read', 'COR_EnuTypeGroup_Read', 'COR_EnuTypeGroup_Read');
		super.setMainDescription('enum.new', 'enum.detail');
		if (this.styleFormNew) {
			this.formData.identifier = String(this.$router.currentRoute.query.identifier);
		}
		this.mainDataChanged = false;
		this.createdBase();
	};

	goBackOwn() {
		this.$router.back();
	}

	preventRefresh(event: any) {
		if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
			event.preventDefault();
			event.returnValue = "";
		}
	}

	beforeMount() {
		window.addEventListener("beforeunload", this.preventRefresh);
	}

	beforeDestroy() {
		window.removeEventListener("beforeunload", this.preventRefresh);
		this.$store.commit("formIsInEditMode", false);
		this.$store.commit("mainDataChanged", false);
	}

	///hlaska o prekroceni inputu po Ctrl+V
	protected infoShortInput(maxLength: string): void {
		this.infoShortInputBase(maxLength);
	}

	mounted() {
		super.mounted();
	};

}

